__turbopack_context__.v({
  "active": "toolLinkItem-module-scss-module__0ObGgG__active",
  "badge": "toolLinkItem-module-scss-module__0ObGgG__badge",
  "beta": "toolLinkItem-module-scss-module__0ObGgG__beta",
  "link": "toolLinkItem-module-scss-module__0ObGgG__link",
  "mbl": "toolLinkItem-module-scss-module__0ObGgG__mbl",
  "mbm": "toolLinkItem-module-scss-module__0ObGgG__mbm",
  "mbn": "toolLinkItem-module-scss-module__0ObGgG__mbn",
  "mbs": "toolLinkItem-module-scss-module__0ObGgG__mbs",
  "mbx": "toolLinkItem-module-scss-module__0ObGgG__mbx",
  "mbxl": "toolLinkItem-module-scss-module__0ObGgG__mbxl",
  "mbxxl": "toolLinkItem-module-scss-module__0ObGgG__mbxxl",
  "ml": "toolLinkItem-module-scss-module__0ObGgG__ml",
  "mll": "toolLinkItem-module-scss-module__0ObGgG__mll",
  "mlm": "toolLinkItem-module-scss-module__0ObGgG__mlm",
  "mln": "toolLinkItem-module-scss-module__0ObGgG__mln",
  "mls": "toolLinkItem-module-scss-module__0ObGgG__mls",
  "mlx": "toolLinkItem-module-scss-module__0ObGgG__mlx",
  "mlxl": "toolLinkItem-module-scss-module__0ObGgG__mlxl",
  "mlxxl": "toolLinkItem-module-scss-module__0ObGgG__mlxxl",
  "mm": "toolLinkItem-module-scss-module__0ObGgG__mm",
  "mn": "toolLinkItem-module-scss-module__0ObGgG__mn",
  "mrl": "toolLinkItem-module-scss-module__0ObGgG__mrl",
  "mrm": "toolLinkItem-module-scss-module__0ObGgG__mrm",
  "mrn": "toolLinkItem-module-scss-module__0ObGgG__mrn",
  "mrs": "toolLinkItem-module-scss-module__0ObGgG__mrs",
  "mrx": "toolLinkItem-module-scss-module__0ObGgG__mrx",
  "mrxl": "toolLinkItem-module-scss-module__0ObGgG__mrxl",
  "mrxxl": "toolLinkItem-module-scss-module__0ObGgG__mrxxl",
  "ms": "toolLinkItem-module-scss-module__0ObGgG__ms",
  "mtl": "toolLinkItem-module-scss-module__0ObGgG__mtl",
  "mtm": "toolLinkItem-module-scss-module__0ObGgG__mtm",
  "mtn": "toolLinkItem-module-scss-module__0ObGgG__mtn",
  "mts": "toolLinkItem-module-scss-module__0ObGgG__mts",
  "mtx": "toolLinkItem-module-scss-module__0ObGgG__mtx",
  "mtxl": "toolLinkItem-module-scss-module__0ObGgG__mtxl",
  "mtxxl": "toolLinkItem-module-scss-module__0ObGgG__mtxxl",
  "mx": "toolLinkItem-module-scss-module__0ObGgG__mx",
  "mxl": "toolLinkItem-module-scss-module__0ObGgG__mxl",
  "mxxl": "toolLinkItem-module-scss-module__0ObGgG__mxxl",
  "pbl": "toolLinkItem-module-scss-module__0ObGgG__pbl",
  "pbm": "toolLinkItem-module-scss-module__0ObGgG__pbm",
  "pbn": "toolLinkItem-module-scss-module__0ObGgG__pbn",
  "pbs": "toolLinkItem-module-scss-module__0ObGgG__pbs",
  "pbx": "toolLinkItem-module-scss-module__0ObGgG__pbx",
  "pbxl": "toolLinkItem-module-scss-module__0ObGgG__pbxl",
  "pbxxl": "toolLinkItem-module-scss-module__0ObGgG__pbxxl",
  "pl": "toolLinkItem-module-scss-module__0ObGgG__pl",
  "pll": "toolLinkItem-module-scss-module__0ObGgG__pll",
  "plm": "toolLinkItem-module-scss-module__0ObGgG__plm",
  "pln": "toolLinkItem-module-scss-module__0ObGgG__pln",
  "pls": "toolLinkItem-module-scss-module__0ObGgG__pls",
  "plx": "toolLinkItem-module-scss-module__0ObGgG__plx",
  "plxl": "toolLinkItem-module-scss-module__0ObGgG__plxl",
  "plxxl": "toolLinkItem-module-scss-module__0ObGgG__plxxl",
  "pm": "toolLinkItem-module-scss-module__0ObGgG__pm",
  "pn": "toolLinkItem-module-scss-module__0ObGgG__pn",
  "prl": "toolLinkItem-module-scss-module__0ObGgG__prl",
  "prm": "toolLinkItem-module-scss-module__0ObGgG__prm",
  "prn": "toolLinkItem-module-scss-module__0ObGgG__prn",
  "pro": "toolLinkItem-module-scss-module__0ObGgG__pro",
  "prs": "toolLinkItem-module-scss-module__0ObGgG__prs",
  "prx": "toolLinkItem-module-scss-module__0ObGgG__prx",
  "prxl": "toolLinkItem-module-scss-module__0ObGgG__prxl",
  "prxxl": "toolLinkItem-module-scss-module__0ObGgG__prxxl",
  "ps": "toolLinkItem-module-scss-module__0ObGgG__ps",
  "ptl": "toolLinkItem-module-scss-module__0ObGgG__ptl",
  "ptm": "toolLinkItem-module-scss-module__0ObGgG__ptm",
  "ptn": "toolLinkItem-module-scss-module__0ObGgG__ptn",
  "pts": "toolLinkItem-module-scss-module__0ObGgG__pts",
  "ptx": "toolLinkItem-module-scss-module__0ObGgG__ptx",
  "ptxl": "toolLinkItem-module-scss-module__0ObGgG__ptxl",
  "ptxxl": "toolLinkItem-module-scss-module__0ObGgG__ptxxl",
  "px": "toolLinkItem-module-scss-module__0ObGgG__px",
  "pxl": "toolLinkItem-module-scss-module__0ObGgG__pxl",
  "pxxl": "toolLinkItem-module-scss-module__0ObGgG__pxxl",
  "toolWrapper": "toolLinkItem-module-scss-module__0ObGgG__toolWrapper",
  "toolsIcon": "toolLinkItem-module-scss-module__0ObGgG__toolsIcon",
});
